<div class="timeline-container">
<div id="linear-timeline-chartdiv" style="width: 100%; height: 500px"></div>
  <div class="timeline-info" *ngIf="data.length === 0">
    <p>No timeline data available. Please provide data with startDate, endDate, category, and text fields.</p>
  </div>
</div>
